'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('poste', {
    url: '/poste/:id',
    template: '<poste></poste>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/poste/poste.routes.js